import { render, staticRenderFns } from "./bindingCard.vue?vue&type=template&id=27e74738&scoped=true"
import script from "./bindingCard.vue?vue&type=script&lang=js"
export * from "./bindingCard.vue?vue&type=script&lang=js"
import style0 from "./bindingCard.vue?vue&type=style&index=0&id=27e74738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e74738",
  null
  
)

export default component.exports